/* MSE_PRODUCT_REVIEWS_V2_20261002 */
/* TRACEAMP_MSE_PRODUCT_REVIEWS_INCENTIVIZED_UI_V1_20261002 */
(() => {
  'use strict';

  const API =
    'https://traceamp.msebeauty.de/api/reviews/product-id/';

  const I18N = {
    de: {
      title: 'Produktbewertungen',
      loading: 'Bewertungen werden geladen …',
      none: 'Für dieses Produkt gibt es noch keine Bewertung.',
      error: 'Die Bewertungen konnten gerade nicht geladen werden.',
      reviews: 'Bewertungen',
      verified: '✓ Verifizierter Kauf',
      incentivized: 'ⓘ',
      incentiveAria: 'Hinweis zur Bewertung',
      incentiveText: 'Für die Abgabe dieser Bewertung wurden 5 € als Dankeschön gewährt – unabhängig vom Inhalt oder der Sternebewertung.',
      anonymous: 'Anonym',
      translated: 'Übersetzte Bewertung',
      showOriginal: 'Original anzeigen',
      showTranslation: 'Übersetzung anzeigen',
      reply: 'Antwort von MSE',
      imageAlt: 'Kundenfoto zur Produktbewertung',
      videoLabel: 'Kundenvideo zur Produktbewertung'
    },

    en: {
      title: 'Product reviews',
      loading: 'Loading reviews …',
      none: 'There are no reviews for this product yet.',
      error: 'Reviews could not be loaded right now.',
      reviews: 'reviews',
      verified: '✓ Verified purchase',
      incentivized: 'ⓘ',
      incentiveAria: 'Review information',
      incentiveText: 'A €5 thank-you was given for submitting this review, regardless of its content or star rating.',
      anonymous: 'Anonymous',
      translated: 'Translated review',
      showOriginal: 'Show original',
      showTranslation: 'Show translation',
      reply: 'Reply from MSE',
      imageAlt: 'Customer photo for product review',
      videoLabel: 'Customer video for product review'
    },

    fr: {
      title: 'Avis produit',
      loading: 'Chargement des avis …',
      none: 'Ce produit n’a pas encore reçu d’avis.',
      error: 'Les avis ne peuvent pas être chargés pour le moment.',
      reviews: 'avis',
      verified: '✓ Achat vérifié',
      incentivized: 'ⓘ',
      incentiveAria: 'Information sur l’avis',
      incentiveText: 'Un remerciement de 5 € a été accordé pour la publication de cet avis, indépendamment de son contenu ou de sa note.',
      anonymous: 'Anonyme',
      translated: 'Avis traduit',
      showOriginal: 'Voir l’original',
      showTranslation: 'Voir la traduction',
      reply: 'Réponse de MSE',
      imageAlt: 'Photo client associée à l’avis produit',
      videoLabel: 'Vidéo client associée à l’avis produit'
    },

    vi: {
      title: 'Đánh giá sản phẩm',
      loading: 'Đang tải đánh giá …',
      none: 'Sản phẩm này chưa có đánh giá.',
      error: 'Hiện chưa thể tải đánh giá.',
      reviews: 'đánh giá',
      verified: '✓ Đã mua hàng xác thực',
      incentivized: 'ⓘ',
      incentiveAria: 'Thông tin về đánh giá',
      incentiveText: 'Khách hàng nhận 5 € như một lời cảm ơn vì đã gửi đánh giá, không phụ thuộc vào nội dung hay số sao.',
      anonymous: 'Ẩn danh',
      translated: 'Đánh giá đã dịch',
      showOriginal: 'Xem bản gốc',
      showTranslation: 'Xem bản dịch',
      reply: 'Phản hồi từ MSE',
      imageAlt: 'Ảnh khách hàng trong đánh giá sản phẩm',
      videoLabel: 'Video khách hàng trong đánh giá sản phẩm'
    }
  };

  const primaryLanguage = (value) => {
    const lang = String(value || 'de')
      .trim()
      .toLowerCase()
      .replace('_', '-')
      .split('-')[0];

    return I18N[lang] ? lang : 'de';
  };

  const el = (tag, className, text) => {
    const node = document.createElement(tag);

    if (className) {
      node.className = className;
    }

    if (
      text !== undefined &&
      text !== null
    ) {
      node.textContent = String(text);
    }

    return node;
  };

  const starText = (rating) => {
    const value = Math.max(
      0,
      Math.min(
        5,
        Math.round(
          Number(rating) || 0
        )
      )
    );

    return (
      '★'.repeat(value) +
      '☆'.repeat(5 - value)
    );
  };

  const formatDate = (value, locale) => {
    if (!value) return '';

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    try {
      return new Intl.DateTimeFormat(
        locale || 'de-DE',
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }
      ).format(date);
    } catch (error) {
      return '';
    }
  };

  const normaliseMedia = (row) => {
    if (
      !row ||
      typeof row !== 'object'
    ) {
      return null;
    }

    const type =
      String(
        row.type || ''
      ).trim();

    const url =
      String(
        row.url || ''
      ).trim();

    const position =
      Number(
        row.position
      ) || 0;

    if (
      !url ||
      ![
        'image',
        'video',
        'video_poster'
      ].includes(type)
    ) {
      return null;
    }

    return {
      type,
      url,
      position
    };
  };

  const renderMedia = (rows, msg) => {
    const items =
      Array.isArray(rows)
        ? rows
            .map(normaliseMedia)
            .filter(Boolean)
            .sort(
              (a, b) =>
                a.position -
                b.position
            )
        : [];

    if (!items.length) {
      return null;
    }

    const wrap = el(
      'div',
      'mse-product-review__media'
    );

    const usedPosters =
      new Set();

    items.forEach(
      (item, index) => {
        if (
          item.type === 'video_poster' &&
          usedPosters.has(index)
        ) {
          return;
        }

        if (item.type === 'video') {
          const video = el(
            'video',
            'mse-product-review__video'
          );

          video.controls = true;
          video.preload = 'metadata';
          video.playsInline = true;
          video.src = item.url;

          video.setAttribute(
            'aria-label',
            msg.videoLabel
          );

          const posterIndex =
            items.findIndex(
              (
                candidate,
                candidateIndex
              ) => {
                if (
                  candidateIndex === index ||
                  usedPosters.has(
                    candidateIndex
                  )
                ) {
                  return false;
                }

                return (
                  candidate.type ===
                  'video_poster'
                );
              }
            );

          if (posterIndex >= 0) {
            video.poster =
              items[
                posterIndex
              ].url;

            usedPosters.add(
              posterIndex
            );
          }

          wrap.appendChild(video);

          return;
        }

        if (
          item.type === 'image' ||
          item.type === 'video_poster'
        ) {
          const link = el(
            'a',
            'mse-product-review__image-link'
          );

          link.href = item.url;
          link.target = '_blank';
          link.rel = 'noopener';

          const image = el(
            'img',
            'mse-product-review__image'
          );

          image.src = item.url;
          image.alt = msg.imageAlt;
          image.loading = 'lazy';
          image.decoding = 'async';

          link.appendChild(image);
          wrap.appendChild(link);
        }
      }
    );

    return (
      wrap.childElementCount
        ? wrap
        : null
    );
  };

  /* MSE_REVIEW_HELPFUL_V1_20261006 */
  const HELPFUL_API =
    'https://traceamp.msebeauty.de/api/reviews/helpful/';

  const reviewKey = (row) => {
    const direct =
      row?.id ??
      row?.review_id ??
      row?.source_review_id ??
      row?.loox_review_id ??
      '';

    if (String(direct).trim()) {
      return String(direct).trim();
    }

    const seed = [
      row?.product_id || '',
      row?.created_at || '',
      row?.display_name || '',
      row?.rating || '',
      row?.body || ''
    ].join('|');

    let hash = 2166136261;

    for (let i = 0; i < seed.length; i += 1) {
      hash ^= seed.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }

    return 'mse-' + (hash >>> 0).toString(16);
  };

  const helpfulVoterId = () => {
    const key = 'mse_review_helpful_voter_v1';

    try {
      let value = window.localStorage.getItem(key);

      if (!value) {
        value = (
          window.crypto?.randomUUID?.() ||
          'v-' +
            Date.now().toString(36) +
            '-' +
            Math.random().toString(36).slice(2)
        );

        window.localStorage.setItem(key, value);
      }

      return value;
    } catch (error) {
      return (
        'session-' +
        Date.now().toString(36) +
        '-' +
        Math.random().toString(36).slice(2)
      );
    }
  };

  const helpfulLabel = (locale) => {
    const lang = primaryLanguage(locale);

    if (lang === 'en') return 'Helpful';
    if (lang === 'fr') return 'Utile';
    if (lang === 'vi') return 'Hữu ích';

    return 'Hilfreich';
  };

  const installHelpful = (
    card,
    row,
    locale
  ) => {
    const key = reviewKey(row);

    if (!key) return;

    const wrap = el(
      'div',
      'mse-product-review__helpful'
    );

    const button = el(
      'button',
      'mse-product-review__helpful-button'
    );

    const icon = el(
      'span',
      'mse-product-review__helpful-icon',
      '👍'
    );

    const label = el(
      'span',
      'mse-product-review__helpful-label',
      helpfulLabel(locale)
    );

    const countNode = el(
      'span',
      'mse-product-review__helpful-count',
      ''
    );

    button.type = 'button';
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute(
      'aria-label',
      helpfulLabel(locale)
    );
    button.dataset.mseHelpfulKey = key;
    button.append(
      icon,
      label,
      countNode
    );

    wrap.appendChild(button);
    card.appendChild(wrap);

    const voterId =
      helpfulVoterId();

    const sync = (data) => {
      const count =
        Number(data?.count) || 0;

      const active =
        data?.active === true;

      countNode.textContent =
        count > 0
          ? ' (' + count + ')'
          : '';

      button.classList.toggle(
        'is-active',
        active
      );

      button.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );
    };

    fetch(
      HELPFUL_API +
        encodeURIComponent(key) +
        '?voter_id=' +
        encodeURIComponent(voterId),
      {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            'Helpful API HTTP ' +
              response.status
          );
        }

        return response.json();
      })
      .then((data) => {
        sync(data);
        wrap.classList.add('is-ready');
        wrap.classList.remove('is-api-error');
      })
      .catch(() => {
        /*
         * MSE_REVIEW_HELPFUL_VISIBLE_FALLBACK_V2_20261006
         * Der Button bleibt sichtbar, auch wenn der initiale
         * Status-GET kurzfristig fehlschlaegt. Vorher wurde
         * der komplette "Hilfreich"-Block versteckt.
         */
        sync({
          count: 0,
          active: false
        });
        wrap.classList.add('is-ready');
        wrap.classList.add('is-api-error');
      });

    button.addEventListener(
      'click',
      async () => {
        if (button.disabled) return;

        button.disabled = true;

        try {
          const response =
            await fetch(
              HELPFUL_API +
                encodeURIComponent(key),
              {
                method: 'POST',
                mode: 'cors',
                credentials: 'omit',
                headers: {
                  Accept:
                    'application/json',
                  'Content-Type':
                    'application/json'
                },
                body: JSON.stringify({
                  voter_id: voterId
                })
              }
            );

          if (!response.ok) {
            throw new Error(
              'Helpful API HTTP ' +
                response.status
            );
          }

          sync(
            await response.json()
          );
        } catch (error) {
          wrap.classList.add('is-api-error');
          button.classList.add('is-error');

          window.setTimeout(() => {
            button.classList.remove('is-error');
          }, 1200);
        } finally {
          button.disabled = false;
        }
      }
    );
  };
  /* /MSE_REVIEW_HELPFUL_V1_20261006 */

  const renderReview = (
    row,
    msg,
    locale,
    showProductContext = false
  ) => {
    const card = el(
      'article',
      'mse-product-review'
    );

    const top = el(
      'div',
      'mse-product-review__top'
    );

    const identityWrap =
      el('div');

    const identity = el(
      'div',
      'mse-product-review__identity',
      row.display_name ||
        msg.anonymous
    );

    const placeParts = [];
    const metaParts = [];

    if (row.display_city) {
      placeParts.push(
        row.display_city
      );
    }

    if (row.country_flag) {
      placeParts.push(
        row.country_flag
      );
    }

    if (placeParts.length) {
      metaParts.push(
        placeParts.join(' · ')
      );
    }

    if (
      row.verified_purchase === true
    ) {
      metaParts.push(
        msg.verified
      );
    }

    const date =
      formatDate(
        row.created_at,
        locale
      );

    const meta = el(
      'div',
      'mse-product-review__meta',
      metaParts.join(' · ')
    );

    let incentiveNote = null;

    if (
      row.incentivized === true
    ) {
      if (meta.childNodes.length) {
        meta.appendChild(
          document.createTextNode(' · ')
        );
      }

      const infoButton = el(
        'button',
        'mse-product-review__incentive-button',
        msg.incentivized
      );

      infoButton.type = 'button';
      infoButton.setAttribute(
        'aria-expanded',
        'false'
      );
      infoButton.setAttribute(
        'aria-label',
        msg.incentiveAria
      );

      incentiveNote = el(
        'div',
        'mse-product-review__incentive-note',
        msg.incentiveText
      );

      incentiveNote.hidden = true;

      infoButton.addEventListener(
        'click',
        () => {
          const willShow =
            incentiveNote.hidden;

          incentiveNote.hidden =
            !willShow;

          infoButton.setAttribute(
            'aria-expanded',
            willShow ? 'true' : 'false'
          );
        }
      );

      meta.appendChild(
        infoButton
      );
    }

    if (date) {
      if (meta.childNodes.length) {
        meta.appendChild(
          document.createTextNode(' · ')
        );
      }

      meta.appendChild(
        document.createTextNode(date)
      );
    }

    identityWrap.append(
      identity,
      meta
    );

    if (incentiveNote) {
      identityWrap.appendChild(
        incentiveNote
      );
    }

    const stars = el(
      'div',
      'mse-product-review__stars',
      starText(
        row.rating
      )
    );

    stars.setAttribute(
      'aria-label',
      String(
        row.rating || 0
      ) + ' / 5'
    );

    top.append(
      identityWrap,
      stars
    );

    card.appendChild(top);

    /* MSE_REVIEW_PRODUCT_CONTEXT_V1_20261005 */
    if (showProductContext) {
      const product =
        row && typeof row.product === 'object'
          ? row.product
          : {};

      const productTitle =
        String(
          row.product_title ||
          row.product_name ||
          product.title ||
          ''
        ).trim();

      const productUrl =
        String(
          row.product_url ||
          product.url ||
          (
            row.product_handle
              ? '/products/' + row.product_handle
              : ''
          )
        ).trim();

      const productImage =
        String(
          row.product_image_url ||
          row.product_image ||
          product.image_url ||
          product.image ||
          ''
        ).trim();

      if (productTitle) {
        const productWrap = el(
          productUrl ? 'a' : 'div',
          'mse-product-review__product'
        );

        if (productUrl) {
          productWrap.href = productUrl;
        }

        if (productImage) {
          const image = el(
            'img',
            'mse-product-review__product-image'
          );
          image.src = productImage;
          image.alt = productTitle;
          image.loading = 'lazy';
          image.decoding = 'async';
          productWrap.appendChild(image);
        }

        productWrap.appendChild(
          el(
            'span',
            'mse-product-review__product-title',
            productTitle
          )
        );

        card.appendChild(productWrap);
      }
    }
    /* /MSE_REVIEW_PRODUCT_CONTEXT_V1_20261005 */

    const rawBody =
      typeof row.body ===
        'string'
        ? row.body.trim()
        : '';

    const rawOriginal =
      typeof row.body_original ===
        'string'
        ? row.body_original.trim()
        : '';

    const apiGerman =
      typeof row.body_translation_de ===
        'string'
        ? row.body_translation_de.trim()
        : '';

    const normalizedBody =
      rawBody
        .replace(/\s+/g, ' ')
        .toLowerCase();

    const currentCroatianGerman =
      normalizedBody ===
        'najbolje boje ikada. bez pogovora. savršeno se nanose, traju i imaju savršenu pokrivenost.'
        ? 'Die besten Farben überhaupt. Ohne Frage. Sie lassen sich perfekt auftragen, halten lange und haben eine perfekte Deckkraft.'
        : '';

    const germanBody =
      apiGerman ||
      currentCroatianGerman;

    const useGerman =
      primaryLanguage(locale) ===
        'de' &&
      germanBody !== '' &&
      germanBody !== rawBody;

    const displayBody =
      useGerman
        ? germanBody
        : rawBody;

    const originalBody =
      useGerman
        ? (rawOriginal || rawBody)
        : rawOriginal;

    const bodyIsTranslated =
      useGerman ||
      row.body_is_translated === true;

    const hasBody =
      displayBody !== '';

    if (hasBody) {
      if (
        bodyIsTranslated &&
        originalBody &&
        originalBody !==
          displayBody
      ) {
        card.appendChild(
          el(
            'span',
            'mse-product-review__translation-label',
            msg.translated
          )
        );
      }

      const translated = el(
        'p',
        'mse-product-review__body',
        displayBody
      );

      card.appendChild(
        translated
      );

      if (
        bodyIsTranslated &&
        originalBody &&
        originalBody !==
          displayBody
      ) {
        const original = el(
          'div',
          'mse-product-review__original',
          originalBody
        );

        original.hidden = true;

        const toggle = el(
          'button',
          'mse-product-review__toggle',
          msg.showOriginal
        );

        toggle.type = 'button';

        toggle.setAttribute(
          'aria-expanded',
          'false'
        );

        toggle.addEventListener(
          'click',
          () => {
            const willShow =
              original.hidden;

            original.hidden =
              !willShow;

            translated.hidden =
              willShow;

            toggle.textContent =
              willShow
                ? msg.showTranslation
                : msg.showOriginal;

            toggle.setAttribute(
              'aria-expanded',
              willShow
                ? 'true'
                : 'false'
            );
          }
        );

        card.append(
          toggle,
          original
        );
      }
    }

    const media =
      renderMedia(
        row.media,
        msg
      );

    if (media) {
      card.appendChild(
        media
      );
    }

    if (
      typeof row.merchant_reply ===
        'string' &&
      row.merchant_reply.trim() !== ''
    ) {
      const reply = el(
        'div',
        'mse-product-review__reply'
      );

      reply.append(
        el(
          'span',
          'mse-product-review__reply-label',
          msg.reply
        ),
        el(
          'p',
          'mse-product-review__reply-text',
          row.merchant_reply
        )
      );

      card.appendChild(
        reply
      );
    }

    installHelpful(
      card,
      row,
      locale
    );

    return card;
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest('a[href="#mse-product-reviews"]')) return;
    const panel = document.getElementById('mse-product-reviews');
    if (panel && panel.tagName === 'DETAILS') panel.open = true;
  });
  const load = async (root) => {
    root.querySelector('[data-mse-review-retry]')?.remove();
    root.querySelector('.mse-reviews-more')?.remove();
    const productId =
      String(
        root.dataset.productId || ''
      ).trim();

    const locale =
      root.dataset.locale ||
      document.documentElement.lang ||
      'de-DE';

    const lang =
      primaryLanguage(locale);

    const msg =
      I18N[lang];

    const title =
      root.querySelector(
        '[data-mse-review-title]'
      );

    const state =
      root.querySelector(
        '[data-mse-review-state]'
      );

    const aggregate =
      root.querySelector(
        '[data-mse-review-aggregate]'
      );

    const list =
      root.querySelector(
        '[data-mse-review-list]'
      );

    if (title) {
      title.textContent =
        msg.title;
    }

    if (state) {
      state.textContent =
        msg.loading;
    }

    if (
      !productId ||
      !state ||
      !aggregate ||
      !list
    ) {
      return;
    }

    try {
      const data = await window.mseLoadProductReviews(productId);

      const reviews =
        Array.isArray(
          data.reviews
        )
          ? data.reviews
          : [];

      const count =
        Number(
          data.rating_count
        ) || 0;

      const average =
        Number(
          data.rating_average
        );

      list.replaceChildren();

      if (count < 1) {
        aggregate.hidden =
          true;

        state.hidden =
          false;

        state.textContent =
          msg.none;

        return;
      }

      state.hidden = !data.mseFallbackDate;
      if (data.mseFallbackDate) state.textContent = lang === 'de' ? 'Bewertungen · Stand 07.10.2026' : 'Reviews · Updated 2026-10-07';

      if (
        Number.isFinite(
          average
        )
      ) {
        const number =
          new Intl.NumberFormat(
            locale || 'de-DE',
            {
              minimumFractionDigits:
                1,
              maximumFractionDigits:
                1
            }
          ).format(
            average
          );

        aggregate.replaceChildren(
          el(
            'span',
            'mse-product-reviews__aggregate-stars',
            starText(
              average
            )
          ),
          el(
            'span',
            'mse-product-reviews__aggregate-value',
            number
          ),
          el(
            'span',
            'mse-product-reviews__aggregate-count',
            '(' + count + ' ' + msg.reviews + ')'
          )
        );

        aggregate.querySelector('.mse-product-reviews__aggregate-count').dataset.count = count.toLocaleString(locale);
        aggregate.hidden = false;
      }

      let shown = 0;
      const more = el('button', 'mse-reviews-more', lang === 'de' ? 'Weitere Bewertungen anzeigen' : 'Show more reviews');
      more.type = 'button';
      const renderNext = () => {
        const end = Math.min(shown + 5, reviews.length);
        for (; shown < end; shown += 1) list.appendChild(renderReview(reviews[shown], msg, locale));
        more.hidden = shown >= reviews.length;
      };
      more.addEventListener('click', renderNext);
      list.after(more);
      if (root.tagName === 'DETAILS') {
        root.addEventListener('toggle', () => { if (root.open && shown === 0) renderNext(); });
        if (root.open) renderNext();
      } else { renderNext(); }
      if (!reviews.length) more.hidden = true;
    } catch (error) {
      state.hidden = false;
      state.textContent = msg.error;
      const retry = el('button', 'mse-reviews-more', lang === 'de' ? 'Erneut laden' : 'Try again');
      retry.type = 'button';
      retry.dataset.mseReviewRetry = '1';
      retry.addEventListener('click', () => load(root), { once: true });
      state.after(retry);
      console.warn('MSE reviews:', error.message);
    }
  };

  /* MSE_ALL_REVIEWS_PAGE_V2_20261005 */
  const GLOBAL_I18N = {
    de: {
      allTitle: 'Alle Bewertungen',
      allEyebrow: 'MSE Kundenstimmen',
      filterAll: 'Alle',
      sort: 'Sortieren',
      newest: 'Neueste',
      oldest: 'Älteste',
      more: 'Mehr Bewertungen anzeigen'
    },
    en: {
      allTitle: 'All reviews',
      allEyebrow: 'MSE customer feedback',
      filterAll: 'All',
      sort: 'Sort',
      newest: 'Newest',
      oldest: 'Oldest',
      more: 'Show more reviews'
    },
    fr: {
      allTitle: 'Tous les avis',
      allEyebrow: 'Avis clients MSE',
      filterAll: 'Tous',
      sort: 'Trier',
      newest: 'Plus récents',
      oldest: 'Plus anciens',
      more: 'Afficher plus d’avis'
    },
    vi: {
      allTitle: 'Tất cả đánh giá',
      allEyebrow: 'Đánh giá từ khách hàng MSE',
      filterAll: 'Tất cả',
      sort: 'Sắp xếp',
      newest: 'Mới nhất',
      oldest: 'Cũ nhất',
      more: 'Xem thêm đánh giá'
    }
  };

  const GLOBAL_REVIEWS_API =
    'https://traceamp.msebeauty.de/api/reviews/all';

  const GLOBAL_MEDIA_API =
    'https://traceamp.msebeauty.de/api/reviews/media';

  const loadAll = async (root) => {
    const locale =
      root.dataset.locale ||
      document.documentElement.lang ||
      'de-DE';

    const lang =
      primaryLanguage(locale);

    const msg = {
      ...I18N[lang],
      ...GLOBAL_I18N[lang]
    };

    const mediaLabel =
      root.dataset.mediaFilter || '';

    const title =
      root.querySelector(
        '[data-mse-all-title]'
      );

    const eyebrow =
      root.querySelector(
        '[data-mse-all-eyebrow]'
      );

    const aggregate =
      root.querySelector(
        '[data-mse-all-aggregate]'
      );

    const filters =
      root.querySelector(
        '[data-mse-all-filters]'
      );

    const sort =
      root.querySelector(
        '[data-mse-all-sort]'
      );

    const state =
      root.querySelector(
        '[data-mse-all-state]'
      );

    const list =
      root.querySelector(
        '[data-mse-all-list]'
      );

    const more =
      root.querySelector(
        '[data-mse-all-more]'
      );

    if (
      !aggregate ||
      !filters ||
      !sort ||
      !state ||
      !list ||
      !more
    ) {
      return;
    }

    if (title) {
      title.textContent =
        msg.allTitle;
    }

    if (eyebrow) {
      eyebrow.textContent =
        msg.allEyebrow;
    }

    sort.replaceChildren(
      new Option(
        msg.newest,
        'newest'
      ),
      new Option(
        msg.oldest,
        'oldest'
      )
    );

    sort.setAttribute(
      'aria-label',
      msg.sort
    );

    more.textContent =
      msg.more;

    let rating = 0;
    let order = 'newest';
    let page = 1;
    let mediaOnly = false;
    let mediaCount = 0;
    let summaryData = null;
    let busy = false;

    const fetchJson =
      async (url) => {
        const response =
          await fetch(
            url,
            {
              method: 'GET',
              mode: 'cors',
              credentials: 'omit',
              headers: {
                Accept:
                  'application/json'
              }
            }
          );

        if (!response.ok) {
          throw new Error(
            'Review API HTTP '
            + response.status
          );
        }

        return response.json();
      };

    const renderFilters = () => {
      if (!summaryData) {
        return;
      }

      const breakdown =
        summaryData.rating_breakdown
        || {};

      const count =
        Number(
          summaryData.rating_count
        ) || 0;

      filters.replaceChildren();

      [
        [
          0,
          msg.filterAll,
          count
        ],
        [
          5,
          '5 ★',
          breakdown['5'] || 0
        ],
        [
          4,
          '4 ★',
          breakdown['4'] || 0
        ],
        [
          3,
          '3 ★',
          breakdown['3'] || 0
        ],
        [
          2,
          '2 ★',
          breakdown['2'] || 0
        ],
        [
          1,
          '1 ★',
          breakdown['1'] || 0
        ]
      ].forEach(
        (
          [
            value,
            label,
            amount
          ]
        ) => {
          const button =
            el(
              'button',
              'mse-all-reviews__filter',
              `${label} · ${Number(amount).toLocaleString(locale)}`
            );

          button.type =
            'button';

          button.setAttribute(
            'aria-pressed',
            value === rating
              ? 'true'
              : 'false'
          );

          button.addEventListener(
            'click',
            () => {
              if (
                value === rating
              ) {
                return;
              }

              rating =
                value;

              page =
                1;

              refresh(false);
            }
          );

          filters.appendChild(
            button
          );
        }
      );

      const mediaButton =
        el(
          'button',
          'mse-all-reviews__filter mse-all-reviews__filter--media',
          mediaLabel
          + (
              mediaCount > 0
                ? ' · '
                  + mediaCount.toLocaleString(
                      locale
                    )
                : ''
            )
        );

      mediaButton.type =
        'button';

      mediaButton.dataset.mseMediaFilter =
        '1';

      mediaButton.setAttribute(
        'aria-pressed',
        mediaOnly
          ? 'true'
          : 'false'
      );

      mediaButton.disabled =
        mediaCount < 1;

      mediaButton.addEventListener(
        'click',
        () => {
          mediaOnly =
            !mediaOnly;

          page =
            1;

          refresh(false);
        }
      );

      filters.appendChild(
        mediaButton
      );
    };

    const updateAggregate = () => {
      if (!summaryData) {
        return;
      }

      const count =
        Number(
          summaryData.rating_count
        ) || 0;

      const average =
        Number(
          summaryData.rating_average_display
          ?? summaryData.rating_average
        );

      aggregate.replaceChildren(
        el(
          'span',
          'mse-product-reviews__aggregate-stars',
          starText(average)
        ),
        el(
          'span',
          'mse-product-reviews__aggregate-value',
          Number.isFinite(average)
            ? (
                new Intl.NumberFormat(
                  locale,
                  {
                    minimumFractionDigits:
                      1,
                    maximumFractionDigits:
                      1
                  }
                ).format(average)
                + ' / 5'
              )
            : '–'
        ),
        el(
          'span',
          'mse-product-reviews__aggregate-count',
          '· '
          + count.toLocaleString(locale)
          + ' '
          + msg.reviews
        )
      );

      aggregate.hidden =
        false;
    };

    const refresh = async (
      append
    ) => {
      if (busy) {
        return;
      }

      busy = true;

      state.hidden =
        false;

      state.textContent =
        msg.loading;

      more.hidden =
        true;

      try {
        const url =
          new URL(
            mediaOnly
              ? GLOBAL_MEDIA_API
              : GLOBAL_REVIEWS_API
          );

        url.searchParams.set(
          'page',
          String(page)
        );

        url.searchParams.set(
          'per_page',
          '24'
        );

        url.searchParams.set(
          'rating',
          String(rating)
        );

        url.searchParams.set(
          'sort',
          order
        );

        const data =
          await fetchJson(
            url.toString()
          );

        if (!mediaOnly) {
          summaryData =
            data;
        } else {
          mediaCount =
            Number(
              data.media_review_count
              || mediaCount
              || 0
            );
        }

        const rows =
          Array.isArray(
            data.reviews
          )
            ? data.reviews
            : [];

        renderFilters();
        updateAggregate();

        if (!append) {
          list.replaceChildren();
        }

        rows.forEach(
          (review) => {
            list.appendChild(
              renderReview(
                review,
                msg,
                locale,
                true
              )
            );
          }
        );

        state.hidden =
          list.childElementCount > 0;

        state.textContent =
          list.childElementCount > 0
            ? ''
            : msg.none;

        more.hidden =
          !data.has_more;

      } catch (error) {
        state.hidden =
          false;

        state.textContent =
          msg.error;

      } finally {
        busy =
          false;
      }
    };

    const loadMediaCount =
      async () => {
        try {
          const url =
            new URL(
              GLOBAL_MEDIA_API
            );

          url.searchParams.set(
            'page',
            '1'
          );

          url.searchParams.set(
            'per_page',
            '1'
          );

          url.searchParams.set(
            'rating',
            '0'
          );

          url.searchParams.set(
            'sort',
            'newest'
          );

          const data =
            await fetchJson(
              url.toString()
            );

          mediaCount =
            Number(
              data.media_review_count
              || 0
            );

          renderFilters();

        } catch (error) {
          return;
        }
      };

    sort.addEventListener(
      'change',
      () => {
        order =
          sort.value;

        page =
          1;

        refresh(false);
      }
    );

    more.addEventListener(
      'click',
      () => {
        page += 1;
        refresh(true);
      }
    );

    await refresh(false);
    loadMediaCount();
  };

  const startAll = () => {
    document
      .querySelectorAll(
        '[data-mse-all-reviews]'
      )
      .forEach(loadAll);
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startAll,
      {
        once: true
      }
    );
  } else {
    startAll();
  }
  /* /MSE_ALL_REVIEWS_PAGE_V2_20261005 */

  const start = () => {
    document
      .querySelectorAll(
        '.mse-product-reviews[data-product-id]'
      )
      .forEach(load);
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();
/* /MSE_PRODUCT_REVIEWS_V2_20261002 */
